// extracted by mini-css-extract-plugin
export var container = "_5z-0";
export var error = "_5z-9";
export var label = "_5z-5";
export var light = "_5z-6";
export var md = "_5z-3";
export var sm = "_5z-2";
export var thin = "_5z-8";
export var thinBold = "_5z-7";
export var vertical = "_5z-4";
export var xs = "_5z-1";